// extracted by mini-css-extract-plugin
module.exports = {"Title":"_1OGPn","Catalog":"XnwFy","Content":"W9oRN"};